import api from '../../services/api';

// Texto do erro devolvido pelo servidor (primeiro campo com problema) ou uma mensagem padrão.
export const textoDoErro = (err, padrao) => {
  const detalhe = err?.response?.data;
  const primeiroCampo = detalhe && typeof detalhe === 'object' ? Object.values(detalhe)[0] : null;
  return (Array.isArray(primeiroCampo) ? primeiroCampo[0] : primeiroCampo) || detalhe?.detail || padrao;
};

export const situacaoConfig = {
  aguardando_projeto: { label: 'Aguardando projeto', color: 'warning' },
  com_projetos: { label: 'Com projetos', color: 'success' },
};

export const tamanhoLegivel = (bytes) => (bytes < 1024 * 1024
  ? `${Math.max(1, Math.round(bytes / 1024))} KB`
  : `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`);

const mensagemDoErroDeArquivo = async (err) => {
  // Quando pedimos um arquivo (blob) e o servidor responde erro, a mensagem também vem como blob.
  try {
    const dados = err?.response?.data;
    if (dados instanceof Blob) {
      const texto = JSON.parse(await dados.text());
      return texto.detail || 'Não foi possível abrir o contrato.';
    }
    return dados?.detail || 'Não foi possível abrir o contrato.';
  } catch {
    return 'Não foi possível abrir o contrato.';
  }
};

// O contrato passa pelo servidor com o login do usuário (não existe link público).
export const abrirArquivoContrato = async (contrato) => {
  const nome = contrato.contrato_nome || `contrato-${contrato.id}`;
  const previa = /\.(pdf|png|jpe?g)$/i.test(nome);
  // A aba precisa ser aberta já no clique, antes da espera, senão o navegador bloqueia.
  const janela = previa ? window.open('', '_blank') : null;
  try {
    const res = await api.get(`/contratos/${contrato.id}/arquivo/`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    if (janela) {
      janela.location.href = url;
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.download = nome;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch (err) {
    if (janela) janela.close();
    throw new Error(await mensagemDoErroDeArquivo(err));
  }
};
